var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.imagePath(),"alt":"Skillbox"}})])}
var staticRenderFns = []

export { render, staticRenderFns }